<template>
  <v-dialog v-model="dialog" max-width="500px" :persistent="loading" @click:outside="close">
    <v-card class="pa-4">
      <v-card-title class="justify-center text-center">Tem certeza que deseja <br />excluir este anexo?</v-card-title>
      <v-card-actions class="mt-4">
        <v-spacer></v-spacer>
        <v-btn color="primary" class="mr-2 mt-2" outlined @click="close" :disabled="loading">Cancelar</v-btn>
        <v-btn color="primary" class="mt-2" @click="destroy" :loading="loading">Sim</v-btn>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import RENTAL from '@/services/rental'

export default {
  data: () => ({
    dialog: false,
    loading: false,
    valid: true,
    rental: null,
    attachment: null,
  }),
  methods: {
    async destroy() {
      try {
        this.loading = true

        var response = await RENTAL.attachment.destroy(this.rental.id, this.attachment.id)

        this.$emit('success', response.attachment)
        this.loading = false
        this.close()
      } catch (error) {
        this.loading = false
        this.$toast.fire({
          icon: 'error',
          title: error.message || 'Erro ao salvar pagamento',
        })
        this.$emit('error', error)
      }
    },
    open({ rental, attachment }) {
      this.attachment = attachment
      this.rental = rental
      this.dialog = true
    },
    close() {
      if (this.loading) return
      this.dialog = false
      this.loading = false
      this.rental = null
    },
  },
  mounted() {
    this.$parent.$on('delete-attachment', this.open)
  },
}
</script>

<style></style>
